/**
 * @author PoornaChandu
 * @description 
 */
import React, {useState,useEffect, useRef} from 'react';
import axios from 'axios';
// import moment from 'moment';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import NoRecords from '../Utils/NoRecords';
import { Tooltip, Input, Button } from 'antd';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { API_FILE, IPAddress, REPORTS } from '../../../commons/api';
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DownloadOutlined,
  SearchOutlined
} from '@ant-design/icons';
const TrendTable = (props) => {
  // const [option, setOption] = useState({});
  // const [data, setData] = useState([]);
  // const [language, setLanguage] = useState(props.language || 'English');
  const [reportName, setReportName] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);
  dayjs.extend(utc);
  useEffect(() => {
    prepareData();
  }, []);
  useEffect(() => {
    if (props.panelData !== undefined && props.panelData !== null) {
      prepareData(props.graphType);
    }
  }, [props.panelData]);
  const getReportNametoDownload = async (excelData, type, SelectedDate, date1) => {
    let payload = {};
    if (type === 'timeRange') {
      payload = {
        PortName: 'Rubus',
        Name: type && type ? type : 'Trends',
        Consumption: 'Trend',
        Data: excelData || [],
        ReportType: 'singleHierarchy',
        GeneratedDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        SelectedDate:
          dayjs.utc(date1.fromDate1).format('YYYY-MM-DD HH:mm') +
          '~' +
          dayjs.utc(date1.toDate1).format('YYYY-MM-DD HH:mm'),
        SelectionType: 'dateRange'
      };
    } else {
      payload = {
        PortName: 'Rubus',
        Name: type && type ? type : 'Trend',
        Consumption: 'Trend',
        Data: excelData || [],
        ReportType: 'singleHierarchy',
        GeneratedDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        SelectedDate:
          dayjs
            .utc(SelectedDate.fromDate)
            
            .format('YYYY-MM-DD HH:mm') +
          '~' +
          dayjs.utc(SelectedDate.toDate).format('YYYY-MM-DD HH:mm'),
        SelectionType: 'dateRange'
      };
    }
    let siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    let options = {};
    options = {
      method: 'POST',
      url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: JSON.stringify(payload)
    };
    return axios(options)
      .then(({ data }) => {
        return data;
      })
      .catch(() => {
        return '';
      });
  };
  const prepareData = async () => {
    const { panelData } = props;
    let dataSource = [];
    if (
      panelData &&
      panelData.trendData &&
      Array.isArray(panelData.trendData) &&
      panelData.trendData.length > 0
    ) {
      let columnsData = panelData.trendData[0] ? Object.keys(panelData.trendData[0]) : [];
      let columns = columnsData
        .filter((col) => col !== 'Colour')
        .map((column) => {
          return {
            title: column,
            dataIndex: column,
            key: column,
            width: 120,
            height: 100,
            ...getColumnSearchProps(column),
            sorter: (a, b) => a.Value - b.Value,
            render(text, record) {
              return {
                children: (
                  <div>
                    {text}
                    {column && column === 'Impact' ? (
                      <span>
                        {record && record.Colour && record.Colour === 'Green' ? (
                          <ArrowUpOutlined style={{ color: 'green' }} />
                        ) : (
                          <ArrowDownOutlined style={{ color: 'red' }} />
                        )}
                      </span>
                    ) : null}
                  </div>
                )
              };
            }
          };
        });
      dataSource = panelData.trendData.map((data) => {
        return {
          ...data,
          DateTime: dayjs
            .utc(data.DateTime, 'YYYY-MM-DD HH:mm:ss')
            
            .format('YYYY-MM-DD HH:mm')
        };
      });
      let { fromDate, toDate, fromDate1, toDate1, fromDate2, toDate2 } = {};
      let reportName = await getReportNametoDownload(
        dataSource,
        panelData.type,
        { fromDate, toDate },
        { fromDate1, toDate1 },
        { fromDate2, toDate2 }
      );
      setColumns(columns);
      setDataSource(dataSource);
      setReportName(reportName && reportName.file ? reportName.file : '');
    }
  };
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={'Search'}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <Tooltip placement="top" title={'Download'}>
          <a href={`${IPAddress.LOCAL}${REPORTS.Reports}/${reportName}`}>
            {' '}
            <DownloadOutlined />
          </a>
        </Tooltip>{' '}
      </div>
      {dataSource && Array.isArray(dataSource) && dataSource.length > 0 ? (
        <StyledTable size="small"
          className="trendTable"
          dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
          columns={columns}
          pagination={true}
          // pagination={
          //   dataSource && dataSource.length <= tableSize ? false : { pageSize: tableSize }
          // }
          scroll={{ x: 1300, y: 200 }}
          bordered={true}
          // style={{ height: '303px',
          //   width: '498px' }}
        />
      ) : (
        <NoRecords />
      )}
    </div>
  );
};
export default TrendTable;